import React, { useState, useCallback } from "react";
import HttpAction from "modules/utils/HttpAction";
const HomeOperationContext = React.createContext({
  state: { homeoperationList: {} },
  actions: {
    getHomeOperation: () => {},
  },
});

const HomeOperationProvider = ({ children }) => {
  const [homeOperationList, setHomeOperationList] = useState([]);
  const [memberProfile, setMemberProfile] = useState([]);

  const [deptSelectList, setDeptSelectList] = useState([]);
  const [memberSelectList, setMemberSelectList] = useState([]);
  
  const getHomeOperationList = useCallback((pageInfo) => {
    HttpAction({
      url:"api/member/operation/list", 
      method: "get",
    }).then((res) => {
      if (res.code === 200) {
        setHomeOperationList(res.data);
      } else {
      }
    });
  }, []);

  const getMemberProfile = useCallback(async(memberId) => {
    await HttpAction({
      url:"api/member/intro/operation", 
      method: "get",
      params: {
        operationMemberId: memberId
      }
    }).then((res) => {
      if (res.code === 200) {
        setMemberProfile(res.data);
      } else {
      }
    });
  }, []);

  const getDeptSelectList = useCallback(async() => {
    await HttpAction({
      url:"api/member/operation/mail/dept/list",
      method: "get",
      params: {}
    }).then((res) => {
      if (res.code === 200) {
        setDeptSelectList(res.data);
      } else {
      }
    });
  }, []);

  const getMemberSelectList = useCallback(async(operationDeptId) => {
    await HttpAction({
      url:"api/member/operation/mail/member/list",
      method: "get",
      params: {
        operationDeptId: operationDeptId
      }
    }).then((res) => {
      if (res.code === 200) {
        setMemberSelectList(res.data);
      } else {
      }
    });
  }, []);

  const sendEmail = useCallback(async(mail,closeModal) => {
    await HttpAction({
      url: "api/member/operation/mail",
      method: "post",
      data: {
        deptMemberId: mail.deptMemberId,
        fromMailAddress: mail.fromMailAddress,
        mailSubject: mail.mailSubject,
        mailContents: mail.mailContents,
      }
    }).then((res) => {
      if (res.code === 200) {
        alert("담당자에게 메일이 전송되었습니다.확인 후 연락 드리겠습니다.")
        closeModal(false)
      } else {
        alert(res.message);
      }
    });
  }, []);

  const value = {
    state: { homeOperationList, memberProfile, deptSelectList, memberSelectList },
    actions: { getHomeOperationList, getMemberProfile, sendEmail, getDeptSelectList, getMemberSelectList },
  };

  return (
    <HomeOperationContext.Provider value={value}>
      {children}
    </HomeOperationContext.Provider>
  );
};

const { Consumer: HomeOperationConsumer } = HomeOperationContext;

export { HomeOperationProvider, HomeOperationConsumer, HomeOperationContext };

export default HomeOperationContext;
